/*
 * @Description: 基金会简介
 * @Autor: lichao
 * @Date: 2021-12-02 11:53:39
 * @LastEditors: lichao
 * @LastEditTime: 2022-01-26 09:49:27
 */

import { useState, useEffect } from "react";
import { gethomelist } from "../../../api/home";

import "./index.less";
import { Tabs } from "antd";

const changeTabPane = (val) => {
  console.log(val,'val')
}

const FoundationIntroduce = () => {
  // 简介
  const [info, setInfo] = useState({});
  useEffect(() => {
    gethomelist().then((res) => {
      const { code, data } = res;
      // console.log(res);
      if (code === 200) {
        setInfo({ ...data.list[0] });
      }
    });
  }, []);

  const tabItems = [
    {
      key: "1",
      label: "我们是谁",
      children: (
        <div
          className="foundation-introduce-container"
          style={{
            background: "url(/image/foundationBack.png) left top no-repeat",
          }}
        >
          <h4>北京基金小镇公益基金会</h4>
          <div className="introduce-container-content">
            <div className="img-content">
              <img src={info.text_image} alt="" />
            </div>
            <div className="text-content">
              <p style={{ textIndent: "2em" }}>
                {info.content}
              </p>
              {/*三个图*/}
              <div className="show-imgs">
                <a href="https://fund-town-1304488676.cos.ap-beijing.myqcloud.com/town_introduction/foundation/introduce/%E5%9F%BA%E9%87%91%E4%BC%9A%E6%B3%95%E4%BA%BA%E7%99%BB%E8%AE%B0%E8%AF%81%E4%B9%A6.jpg" target="_blank" rel="noreferrer">
                  <img src="/image/foundation/one.jpg" alt=""/>
                </a>
                <a href="https://fund-town-1304488676.cos.ap-beijing.myqcloud.com/town_introduction/foundation/introduce/%E7%A4%BE%E4%BC%9A%E7%BB%84%E7%BB%87%E7%AD%89%E7%BA%A7%E8%AF%84%E4%BC%B0%E7%89%8C%E5%8C%BE.jpg" target="_blank" rel="noreferrer">
                  <img src="/image/foundation/two.jpg" alt=""/>
                </a>
                <a href="https://fund-town-1304488676.cos.ap-beijing.myqcloud.com/town_introduction/foundation/introduce/%E7%A4%BE%E4%BC%9A%E7%BB%84%E7%BB%87%E7%AD%89%E7%BA%A7%E8%AF%84%E4%BC%B0%E8%AF%81%E4%B9%A6.jpg" target="_blank" rel="noreferrer">
                  <img src="/image/foundation/three.jpg" alt=""/>
                </a>
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: "使命愿景",
      children: (
        <div
          className="foundation-introduce-container"
          style={{
            background: "url(/image/foundationBack.png) left top no-repeat",
          }}
        >
          <div className="two-tab">
            <p><span className="two-tab-span">使命：</span> 致力公益慈善事业，促进社会和谐与发展</p>
            <p><span className="two-tab-span">愿景：</span>增爱心财富，担社会责任，推动金融向善</p>
            <p><span className="two-tab-span">价值观： </span>平等、担当、合作、创新</p>
            <div className="two-tab-img">
              <img src="https://fund-town-1304488676.cos.ap-beijing.myqcloud.com/town_introduction/foundation/images/shiming.png" alt="" />
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: "组织机构",
      children: (
        <div
          className="foundation-introduce-container3"
          style={{
            background: "url(/image/foundationBack.png) left top no-repeat",
          }}
        >
          <div className="three-tab">
            <p className="three-title">理事长、理事、秘书长介绍</p>
            <div className="three-tab-content">
              <p><span>龚张微</span>，北京基金小镇公益基金会理事长</p>
              <p><span>周一晨</span>，北京基金小镇公益基金会副理事长</p>
              <p><span>钟钟</span>，北京基金小镇公益基金会理事</p>
              <p><span>张剑</span>，北京基金小镇公益基金会理事</p>
              <p><span>庞文军</span>，北京基金小镇公益基金会理事</p>
              <p><span>杨晨茁</span>，北京基金小镇公益基金会理事</p>
              <p><span>李欣</span>，北京基金小镇公益基金会秘书长、流动党支部书记</p>
            </div>
            <p className="three-title">监事介绍</p>
            <div className="three-tab-content">
              <p>卫安己，北京基金小镇公益基金会监事</p>
            </div>
            <p className="three-title">组织架构图</p>
            <div className="three-tab-content chart-img-content">
              <img src="https://fund-town-1304488676.cos.ap-beijing.myqcloud.com/town_introduction/foundation/images/chart.png" alt="" />
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="foundation-introduce w1200" id="foundation-introduce-modal">
      <Tabs defaultActiveKey="1" type="card" onChange={changeTabPane} items={tabItems} />
    </div>
  );
};

export default FoundationIntroduce;
